/**
 * LiveChat v2 bootstrap (Text / LiveChat console snippet). The license id is public in the browser.
 * Shape matches manual_channels + livechat product from the LiveChat "copy code" dialog.
 */
const LIVECHAT_IIFE = `;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))`;

const BOOTSTRAP_FLAG = "__gestionaloLiveChatBootstrap";

export function parseLiveChatLicense(raw: string | undefined): number | null {
  if (raw === undefined || raw === null) {
    return null;
  }
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  const n = Number(trimmed);
  if (!Number.isInteger(n) || n <= 0) {
    return null;
  }
  return n;
}

/** Core inline script: __lc + IIFE (loads tracking.js). */
export function buildLiveChatBootstrapScript(license: number): string {
  return `window.__lc=window.__lc||{};window.__lc.license=${license};window.__lc.integration_name="manual_channels";window.__lc.product_name="livechat"${LIVECHAT_IIFE}`;
}

/** Landing: bootstrap + queued session variable for agents. */
export function buildLiveChatLandingInlineScript(license: number): string {
  return `${buildLiveChatBootstrapScript(license)};window.LiveChatWidget.call("set_session_variables",{gestionalo_app:"landing"});`;
}

/** Portal / SPA: inject once (guarded). Calls are queued until the widget loads. */
export function injectLiveChatBootstrap(license: number): void {
  if (typeof window === "undefined") {
    return;
  }
  const g = globalThis as unknown as Record<string, boolean | undefined>;
  if (g[BOOTSTRAP_FLAG]) {
    return;
  }
  g[BOOTSTRAP_FLAG] = true;
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.textContent = buildLiveChatBootstrapScript(license);
  document.head.appendChild(script);
}
